var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { useAuthProvider, useLucidSdk } from '#context';
import { WorkspaceSsoLoginParamsKeyFactory } from '../../query-key-factories';
export const getWorkspaceSsoLoginParamsQueryFactory = (lucidSdk, workspaceId) => ({
    queryKey: WorkspaceSsoLoginParamsKeyFactory.byWorkspace(workspaceId),
    queryFn: () => lucidSdk.workspaceClient(workspaceId).getSsoLoginParams(),
});
export const useGetWorkspaceSsoLoginParams = (workspaceId, { enabled = true } = {}) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const { currentUser } = useAuthProvider();
    const query = useQuery({
        ...getWorkspaceSsoLoginParamsQueryFactory(lucidSdk, workspaceId),
        enabled: Boolean(currentUser?.email) && enabled,
    });
    return query;
};
_react_refresh_temp_1(useGetWorkspaceSsoLoginParams, "wEg9DMWQ/CI4rGOcHGIhupr8WvQ=", false, () => [useLucidSdk, useAuthProvider, useQuery]);
